import axios from 'axios';
import {
  Box,
  Button,
  ButtonGroup,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React, {
  Dispatch,
  ChangeEvent,
  useEffect,
  useRef,
  useState,
} from 'react';
import { QueryCache, useMutation, useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';
import { useRecoilState } from 'recoil';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import clsx from 'clsx';
import { getYear, lastDayOfMonth, startOfYear } from 'date-fns';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import SearchIcon from '@mui/icons-material/Search';
import { useSession, xapi } from '../../hooks/session';
import { SwSnackbar } from '../commonComponent/views/SwSnackbar';
import SwLoading from '../commonComponent/spinner/SwLoading';
import { SwPagination } from '../commonComponent/tableElement/SwPagination';
import {
  encodeSearchWord,
  firstDayOfMonth,
  getCurrentStartDate,
  getFirstMonthOfYear,
  timestamp2Localestring,
} from '../../common/helper';
import {
  KEY_BOOK_GROUP_LIST,
  KEY_BOOK_INFO_LIST,
  KEY_CLASS_USER_STAT_LIST,
  KEY_USER_LIST,
} from '../../common/key';
import excellog from '../../images/sub/excel_icon.svg';
import {
  getBookGroupList,
  getBookInfoList,
  registerBookGroup,
} from '../../common/api/ApiBook';
import { SwBookGroup } from '../commonComponent/SwBookGroup';
import { SwBookList } from '../commonComponent/SwBookList';
import { uploadFile } from '../../common/api/ApiUpload';
import { RESULT_OK } from '../../common/resultCode';
import { SwClassStatTab } from '../commonComponent/SwClassStatTab';
import { SwUserStatDetail } from '../commonComponent/SwUserStatDetail';
import { ClassRankTable } from './ClassRankTable';
import { SwSelectMonth } from '../commonComponent/SwSelectMonth';
import { SwRwwTab } from '../commonComponent/SwRwwTab';
import { SwTitleDownloadMore } from '../commonComponent/SwTitleDownloadMore';
import { RwwCumulativeStatistics } from './RwwCumulativeStatistics';
import { RwwAverageStatistics } from './RwwAverageStatistics';
import { RwwAchievementStatistics } from './RwwAchievementStatistics';
import { selectSchoolInfoState } from '../../common/atom';
import { RwwMedalStatistics } from './RwwMedalStatistics';
import { getUserList } from '../../common/api/ApiUser';
import {
  downloadClassDailyRwwDataList,
  getClassUserStatList,
} from '../../common/api/ApiClassStat';
import { SwDownloadDialog } from '../commonComponent/views/SwDownloadDialog';
import { RwwMemberStatistics } from './RwwMemberStatistics';

interface Props {}

export const ClassStatistics: React.FC<Props> = () => {
  const { loginVal } = useSession();
  const [schoolClassInfo, setSchoolClassInfo] = useRecoilState(
    selectSchoolInfoState
  );
  const [members, setMembers] = useState<any[]>([]);
  const [targetMonth, setTargetMonth] = useState<any>();
  const [selectTargetType, setSelectTargetType] = useState<string>('all');
  const [selectMember, setSelectMember] = useState<number>(0);
  const [pdfCheck, setPdfCheck] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [rangeDate, setRangeDate] = useState([
    startOfYear(new Date()), // 올해 1월 1일
    new Date(), // 오늘
  ]);
  const [openDownload, setOpenDownload] = useState<boolean>(false);

  var searchWord = '';
  var searchKey = 'user';

  const {
    data,
    isLoading,
    refetch: refetchClassStatUsers,
  } = useQuery(
    KEY_CLASS_USER_STAT_LIST,
    () => {
      if (schoolClassInfo !== undefined && schoolClassInfo !== null) {
        const newData: any = {
          schoolSeq: schoolClassInfo.schoolSeq,
          schoolGrade: schoolClassInfo.schoolGrade,
          schoolClass: schoolClassInfo.schoolClass,
          startDate: rangeDate[0] === null ? 0 : rangeDate[0].getTime(),
          endDate: rangeDate[1] === null ? 0 : rangeDate[1].getTime(),
          page: 0,
          rowsPerPage: 0,
          searchKey: searchKey,
          searchWord: encodeSearchWord(searchKey, searchWord),
          sortByNumber: -1,
          sortByFinish: -1,
          sortByAvg: -1,
          sortByTotal: -1,
          sortByWrite: -1,
        };
        return getClassUserStatList(newData);
      }
      return null;
    },
    {
      onSuccess: res => {
        if (res !== null) {
          setMembers(res.statList);
        } else {
          setMembers([]);
        }
      },
      onError: e => {
        console.log(e);
      },
    }
  );

  const onClickMakingPdfOld = () => {
    const newBox = document.getElementById('pdf_root');
    const lists: any = document.querySelectorAll('.pdf_screen');
    // const lists02: any = document.querySelectorAll('.attendPdf01');

    if (!newBox || !lists.length) return;

    const originalBoxStyle = {
      width: newBox.style.width,
      padding: newBox.style.padding,
    };

    const originalListStyles = Array.from(lists).map((el: any) => ({
      padding: el.style.padding,
    }));

    let newList: any[] = [];
    // eslint-disable-next-line new-cap
    const doc = new jsPDF('p', 'mm', 'a4');

    const getImage = async (x: any, i: number, type: number) => {
      setTimeout(() => {
        html2canvas(x).then(canvas => {
          const newImageFile = canvas.toDataURL('image/png');
          const imgWidth = 170;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          const margin = 20;
          const newImage = document.createElement('img');
          newImage.src = newImageFile;
          newList = [
            ...newList,
            {
              id: type === 1 ? i : i + lists.length,
              img: newImage,
              imgHeight: imgHeight,
            },
          ];

          if (newList.length === lists.length) {
            const sortNewList = newList
              .sort((q, w) => q.id - w.id)
              .filter(el => el.imgHeight);
            sortNewList?.forEach((q, idx) => {
              doc.addImage(q.img, 'JPEG', margin, 20, imgWidth, q.imgHeight);
              if (idx !== sortNewList.length - 1) {
                doc.addPage();
              } else {
                doc.save(`${schoolClassInfo.schoolName} 통계.pdf`);

                // ✅ 스타일 복원
                newBox.style.width = originalBoxStyle.width;
                newBox.style.padding = originalBoxStyle.padding;

                lists.forEach((el: any, ix: number) => {
                  el.style.padding = originalListStyles[ix].padding;
                });

                setPdfCheck(false);
              }
            });
          }
        });
      }, 3000);
    };

    // ✅ PDF 스타일 적용
    newBox.style.width = '1280px';
    newBox.style.padding = '30px 50px';
    newBox.style.backgroundColor = '#fff';

    lists.forEach((el: any) => {
      el.style.padding = '30px 50px';
      el.style.backgroundColor = '#fff';
    });

    for (let i = 0; i < lists.length; i += 1) {
      getImage(lists[i], i, 1);
    }
  };

  const waitForRender = (callback: () => void, count = 3) => {
    if (count <= 0) callback();
    requestAnimationFrame(() => waitForRender(callback, count - 1));
  };

  const waitForRenderPromise = (count = 3) =>
    new Promise<void>(resolve => {
      const step = () => {
        if (count <= 0) resolve();
        else {
          requestAnimationFrame(() => {
            step();
          });
          count -= 1;
        }
      };
      step();
    });

  const captureElement = async (el: HTMLElement) => {
    await waitForRenderPromise();
    const canvas = await html2canvas(el, {
      backgroundColor: '#ffffff',
      useCORS: true,
      scale: 2,
    });
    return canvas.toDataURL('image/png');
  };

  const onClickMakingPdf = async () => {
    if (isGenerating) return;

    setIsGenerating(true);
    setPdfCheck(true); // pdf 스타일 적용용
    await new Promise(res => {
      setTimeout(res, 500);
    }); // pdfCheck 상태 반영 대기

    const root = document.getElementById('pdf_root');
    const targets = Array.from(
      document.querySelectorAll('.pdf_screen')
    ) as HTMLElement[];
    // eslint-disable-next-line new-cap
    const pdf = new jsPDF('p', 'mm', 'a4');

    if (!root || targets.length === 0) return;

    // PDF용 스타일 적용
    root.style.width = '';
    root.style.padding = '';
    targets.forEach((t: any) => {
      t.style.padding = '';
    });

    const imageList = await Promise.all(
      targets.map((el, idx) =>
        captureElement(el).then(img => ({
          id: idx,
          img,
          el,
        }))
      )
    );

    // PDF 페이지 추가
    imageList.forEach((item, idx) => {
      const canvas = item.el;
      const width = 170;
      const height = (canvas.clientHeight * width) / canvas.clientWidth;
      pdf.addImage(item.img, 'PNG', 20, 20, width, height);
      if (idx < imageList.length - 1) {
        pdf.addPage();
      }
    });

    pdf.save(`${schoolClassInfo.schoolName}_통계.pdf`);

    // PDF용 스타일 원복
    root.style.width = '';
    root.style.padding = '';
    root.style.backgroundColor = '#fff';
    targets.forEach(t => {
      t.style.padding = '';
    });

    setPdfCheck(false); // 원래 상태 복원
    setIsGenerating(false);
  };

  const downloadDailyRwwData = (month: any) => {
    const newData: any = {
      schoolSeq: schoolClassInfo.schoolSeq,
      schoolGrade: schoolClassInfo.schoolGrade,
      schoolClass: schoolClassInfo.schoolClass,
      startDate: firstDayOfMonth(month * 1000).getTime(),
      endDate: lastDayOfMonth(month * 1000).getTime(),
      page: 0,
      rowsPerPage: 0,
      searchKey: searchKey,
      searchWord: encodeSearchWord(searchKey, searchWord),
    };
    setOpenDownload(false);
    downloadClassDailyRwwDataList(newData);
  };

  useEffect(() => {
    if (pdfCheck) {
      onClickMakingPdf();
    }
  }, [pdfCheck]);

  useEffect(() => {
    const newTarget = getFirstMonthOfYear(loginVal);
    setTargetMonth(newTarget);
  }, []);

  return (
    <>
      <Paper
        sx={{
          p: '1.5rem',
          backgroundColor: '#fff', // ✅ 흰 배경 지정
          width: pdfCheck ? '1280px' : 'auto', // ✅ PDF용 크기
        }}
        id='pdf_root'
      >
        <SwClassStatTab
          tabValue={2}
          schoolClassInfo={schoolClassInfo}
          setSchoolClassInfo={setSchoolClassInfo}
        />
        <Box className='flex_between'>
          <Box className='flex_start'>
            <TextField
              sx={{ width: '10rem' }}
              select
              value={selectTargetType}
              onChange={evt => {
                const targetType = evt.target.value;
                setSchoolClassInfo((prev: any) => ({
                  ...prev,
                  targetType: targetType,
                  memberSeq: 0,
                }));
                setSelectMember(0);
                setSelectTargetType(targetType);
                if (targetType === 'person') refetchClassStatUsers();
              }}
            >
              <MenuItem key={`target_${0}`} value='all'>
                전체
              </MenuItem>
              <MenuItem key={`target_${1}`} value='person'>
                개인
              </MenuItem>
            </TextField>
            {selectTargetType === 'person' && (
              <TextField
                sx={{ width: '10rem', ml: '1rem' }}
                select
                value={selectMember}
                onChange={evt => {
                  const newSeq = Number(evt.target.value);
                  setSelectMember(newSeq);
                  setSchoolClassInfo((prev: any) => ({
                    ...prev,
                    memberSeq: newSeq,
                  }));
                }}
              >
                <MenuItem key={`target_${9999}`} value={0}>
                  선택
                </MenuItem>
                {members.map((member: any, idx: number) => (
                  <MenuItem key={`target_${idx}`} value={member.seq}>
                    {member.nickname}
                  </MenuItem>
                ))}
              </TextField>
            )}
          </Box>
          <Box>
            <Button
              sx={{ ml: '0rem' }}
              color='info'
              variant='contained'
              onClick={() => setOpenDownload(true)}
            >
              일자별 데이터 다운로드
            </Button>
            <Button
              sx={{ ml: '1rem' }}
              color='info'
              variant='contained'
              onClick={() => setPdfCheck(true)}
            >
              PDF 다운로드
            </Button>
          </Box>
        </Box>
        {selectTargetType === 'all' && (
          <Box sx={{ backgroundColor: '#fff' }} className='pdf_screen'>
            <RwwMemberStatistics startDate={targetMonth} isPdf={pdfCheck} />
          </Box>
        )}
        <Paper
          className='pdf_screen'
          sx={{ mt: '2rem', backgroundColor: '#fff' }}
        >
          <RwwCumulativeStatistics startDate={targetMonth} isPdf={pdfCheck} />
        </Paper>

        <Box
          sx={{ mt: '2rem', backgroundColor: '#fff' }}
          className='pdf_screen'
        >
          <RwwAverageStatistics
            startDate={targetMonth}
            isPdf={pdfCheck}
            isPerson={selectTargetType === 'person'}
          />
        </Box>

        <Box
          sx={{ mt: '2rem', backgroundColor: '#fff' }}
          className='pdf_screen'
        >
          <RwwMedalStatistics startDate={targetMonth} isPdf={pdfCheck} />
        </Box>

        {selectTargetType === 'all' && (
          <Box sx={{ mt: '2rem' }}>
            <SwSelectMonth
              onChangeMonth={item => {
                setTargetMonth(item);
              }}
              showSelectDay={false}
            />
          </Box>
        )}
        {selectTargetType === 'all' && (
          <Box
            sx={{ mt: '0rem', backgroundColor: '#fff' }}
            className='pdf_screen'
          >
            <RwwAchievementStatistics
              startDate={targetMonth}
              isPdf={pdfCheck}
            />
          </Box>
        )}
      </Paper>
      <SwDownloadDialog
        head='일자별 데이터 다운로드'
        open={openDownload}
        onClose={() => setOpenDownload(false)}
        onDownload={(month: any) => downloadDailyRwwData(month)}
      />
    </>
  );
};
